export const state = {
  accessTypes: {
    READ: 1,
    WRITE: 2,
    ADMIN: 3
  },
  infoTypes: {
    USER: 100,
    ENTITY: 110,
    ACTIVITIES: 140,
    ENTITY_STATUS: 120,
    ACTIVITIES_PENDING: 141
  },
  activities: {
    AUDIOLOGY: 1,
    SCREENING: 3,
    DISPENSER_FIELD: 8,
    DISPENSER_PREMISES: 9
  },
  authUserEntityActivities: [],
  authSrvToken: process.env.VUE_APP_AUTH_TOKEN,
  hasLoadedAuthUserEntityActivities: false
}
